import TitleCard from '../components/TitleCard';
import Logo from '../components/Logo';
import { Row, Col, Button } from 'react-bootstrap';
import ValidationInput from '../components/ValidationTextInput';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { stringValidation } from '../services/validation';
import { useAPI } from '../services/api';
import { useState } from 'react';
import '../styles/components/custom-buttons.scss';
import { useHistory } from 'react-router-dom';

const ForgotPasswordPage = ({ title = 'Forgot Password' }) => {
  const api = useAPI();
  const history = useHistory();
  const [usernameSubmitted, setUsernameSubmitted] = useState(false);

  const dataSchema = Yup.object().shape({
    username: stringValidation(),
  });

  const initialValues = {
    username: '',
  };

  const submitClicked = async ({ username }) => {
    await api.get(`/users/forgot/${username}`);
    setUsernameSubmitted(true);
  };

  return (
    <>
      <Logo />
      <Row className="mb-5">
        <Col xs={11} s={9} md={6} className="mx-auto">
          {!usernameSubmitted && (
            <TitleCard title={title}>
              <Formik
                onSubmit={submitClicked}
                initialValues={initialValues}
                validationSchema={dataSchema}
              >
                <Form className="p-3 text-center">
                  <ValidationInput
                    name="username"
                    aria-label="username-input"
                    label=""
                    placeholder="Username"
                    autoComplete="username"
                  />
                  <Button type="submit" className="dark-btn">
                    Submit
                  </Button>
                </Form>
              </Formik>
            </TitleCard>
          )}
          {usernameSubmitted && (
            <TitleCard title="Submitted!">
              <div className="p-3 text-center">
                If that username exists, we will send an email to the associated email address with
                reset instructions.
              </div>
              <button
                type="button"
                data-cy="to-login-button"
                className="dark-btn btn btn-primary"
                onClick={() => history.push('/')}
              >
                Go to Login
              </button>
            </TitleCard>
          )}
        </Col>
      </Row>
    </>
  );
};

export default ForgotPasswordPage;
